import TweenMax from "gsap/TweenMax";
/**
 * demo.js
 * http://www.codrops.com
 *
 * Licensed under the MIT license.
 * http://www.opensource.org/licenses/mit-license.php
 *
 * Copyright 2019, Codrops
 * http://www.codrops.com
 */

class Demo1 {
  constructor() {

    if(navigator.userAgent.toLowerCase().indexOf('firefox') > -1){
      // Do Firefox-related activities
    }else {
      this.initDemo();
    }

   

  }

  isParent(refNode, otherNode) {
    var parent = otherNode.parentNode;
    do {
      if (refNode == parent) {
        return true;
      } else {
        parent = parent.parentNode;
      }
    } while (parent);
    return false;
  }

  initDemo() {
    const { Back } = window;
    this.easing = Back.easeInOut.config(1.7);

    this.cursorWrapper = document.querySelector(".cursor-wrapper");
    this.innerCursor = document.querySelector(".custom-cursor__inner");
    this.outerCursor = document.querySelector(".custom-cursor__outer");

    this.cursorWrapperBox = this.cursorWrapper.getBoundingClientRect();
    this.innerCursorBox = this.innerCursor.getBoundingClientRect();
    this.outerCursorBox = this.outerCursor.getBoundingClientRect();

    document.addEventListener("mousemove", e => {
      this.clientX = e.clientX;
      this.clientY = e.clientY;
    });

    const render = () => {
      TweenMax.set(this.cursorWrapper, {
        x: this.clientX,
        y: this.clientY
      });
      requestAnimationFrame(render);
    };
    requestAnimationFrame(render);

    this.fullCursorSize = 40;
    this.enlargeCursorTween = TweenMax.to(this.outerCursor, 0.3, {
      backgroundColor: "transparent",
      width: this.fullCursorSize,
      height: this.fullCursorSize,
      ease: this.easing,
      paused: true,
      opacity: 0.8,
    });

    this.mainNavHoverTween = TweenMax.to(this.outerCursor, 0.3, {
      backgroundColor: "#df1217",
      opacity: 1,
      width: this.fullCursorSize,
      height: this.fullCursorSize,
      ease: this.easing,
      paused: true,
      opacity: 0.8,
    });


    const handleMouseEnter = () => {
      this.enlargeCursorTween.play();
    };

    const handleMouseLeave = () => {
      this.enlargeCursorTween.reverse();
    };

    /* const menuFollowItems = document.querySelectorAll(".menu--footer-follows a");
    menuFollowItems.forEach(el => {
      el.addEventListener("mouseenter", handleMouseEnter);
      el.addEventListener("mouseleave", handleMouseLeave);
    }); */

    var _this = this;

    const mainNavItems = "a, .cont--video, .home-right .block-block-content .field--name-field-titulo";
    jQuery('body').on('mouseenter',mainNavItems, function () {
      //_this.cursorWrapper.classList.add('');
      /* _this.mainNavHoverTween.play();
      _this.innerCursor.classList.add('link-active');
      _this.innerCursor.classList.remove('is-scrolling'); */

    });
    jQuery('body').on('mouseleave',mainNavItems, function (ev) {
      console.log(this.closest('header').length);
      if(!this.closest('header').length) {
        _this.cursorWrapper.classList.remove('disabled');
      }

      /* _this.mainNavHoverTween.reverse();
      _this.innerCursor.classList.remove('link-active');

      var $el = jQuery(ev.toElement || ev.relatedTarget).closest('.submenu-blk-level-2--subcategories');
      if($el.length && $el[0].offsetHeight < $el[0].scrollHeight) {
        _this.mainNavHoverTween.play();
        _this.innerCursor.classList.add('is-scrolling');
      } */
    });


    jQuery('body').on('mouseenter','header, .submenu_blk-level-2, .submenu_blk-content, .submenu_blk-level-2 a', function () {
      _this.cursorWrapper.classList.add('disabled');
    });
    jQuery('body').on('mouseleave','header', function (ev) {
      _this.cursorWrapper.classList.remove('disabled');
    });
    jQuery('body').on('mouseleave','.submenu-blk-level-2--subcategories', function (ev) {
      /* _this.mainNavHoverTween.reverse();
      _this.innerCursor.classList.remove('is-scrolling'); */
    });

    const scrollItems = document.querySelectorAll(".home-left, .home-right .block-block-content a, .home-left a, .custom-duplicated");
    scrollItems.forEach(el => {

        el.addEventListener("mouseenter", (ev) => {

            this.mainNavHoverTween.play();
            this.innerCursor.classList.add('is-scrolling');

        });
        el.addEventListener("mouseleave", (ev) => {
          this.mainNavHoverTween.reverse();
          this.innerCursor.classList.remove('is-scrolling');
        });

      
    });


    const phoneItems = document.querySelectorAll('a[href^="tel:"]');
    phoneItems.forEach(el => {
      el.addEventListener("mouseenter", () => {
        this.mainNavHoverTween.play();
        this.innerCursor.classList.add('phone');
      });
      el.addEventListener("mouseleave", () => {
        this.mainNavHoverTween.reverse();
        this.innerCursor.classList.remove('phone');
      });
    });

    const externalLinks = document.querySelectorAll('#block-footerfollows a');
    externalLinks.forEach(el => {
      el.addEventListener("mouseenter", () => {
        this.mainNavHoverTween.play();
        this.innerCursor.classList.add('external');
      });
      el.addEventListener("mouseleave", () => {
        this.mainNavHoverTween.reverse();
        this.innerCursor.classList.remove('external');
      });
    });

    // Disabled elements 
    const disabledElements = document.querySelectorAll("input, textarea, select, label, .nice-select, .view-id-donde_comprar.view-display-id-page_1 .view-content, .js-form-type-select:not(.js-form-item-field-categoria-target-id), button:not(.close)");
    const disabledAjaxElements = '.popup-content button:not(.close), input, #videoModal iframe, .facet-item__value';

    disabledElements.forEach(el =>{
      el.addEventListener("mouseenter",() =>{
        this.cursorWrapper.classList.add('disabled');
      });
      el.addEventListener("mouseleave",() =>{
        this.cursorWrapper.classList.remove('disabled');
      });
    });
    
    jQuery('body').on('mouseenter',disabledAjaxElements, function () {
      _this.cursorWrapper.classList.add('disabled');
    });
    jQuery('body').on('mouseleave',disabledAjaxElements, function () {
      _this.cursorWrapper.classList.remove('disabled');
    });

    jQuery('body').on('click',disabledAjaxElements, function () {
      _this.cursorWrapper.classList.remove('disabled');
    });




    const zoomItems = ".product-gallery .product-gallery-principal a";
    jQuery('body').on('mouseenter',zoomItems, function () {
      _this.mainNavHoverTween.play();
      _this.innerCursor.classList.add('is-zoom');
    });
    jQuery('body').on('mouseleave',zoomItems, function () {
      _this.mainNavHoverTween.reverse();
      _this.innerCursor.classList.remove('is-zoom');
    });
    
 
    const closingItems = '.mfp-container, .mfp-close, #videoModal';
    const disableClosingItems = '.mfp-content, .mfp-arrow';

    jQuery('body').on('mouseenter',closingItems, function () {
      _this.mainNavHoverTween.play();
      _this.innerCursor.classList.add('is-closing');
    });
    jQuery('body').on('mouseleave',closingItems, function () {
      _this.mainNavHoverTween.reverse();
      _this.innerCursor.classList.remove('is-closing');
    });

    jQuery('body').on('mouseenter',disableClosingItems, function () {
      _this.mainNavHoverTween.reverse();
      _this.innerCursor.classList.remove('is-closing');
    });

    jQuery('body').on('mouseleave',disableClosingItems, function () {
      _this.mainNavHoverTween.play();
      _this.innerCursor.classList.add('is-closing');
    });

    jQuery('body').on('click',closingItems,function(){
      _this.mainNavHoverTween.reverse();
      _this.innerCursor.classList.remove('is-closing');
    });


    this.bumpCursorTween = TweenMax.to(this.outerCursor, 0.1, {
      scale: 0.7,
      paused: true,
      onComplete: () => {
        TweenMax.to(this.outerCursor, 0.2, {
          scale: 1,
          ease: this.easing
        });
      }
    });
  }
}

export default Demo1;
